// File: src/utils/index.js

// Asset imports
import logoImg from "../assets/img/logo.svg";
import chatImg from "../assets/img/chats.png";
import s2 from "../assets/img/s2.png";
import s3 from "../assets/img/s3.png";
import s4 from "../assets/img/s4.png";
import s5 from "../assets/img/s5.png";
import s6 from "../assets/img/s6.png";
import s7 from "../assets/img/s7.png";
import s8 from "../assets/img/s8.png";
import s9 from "../assets/img/s9.png";
import s10 from "../assets/img/s10.png";
import s11 from "../assets/img/s11.png";

import timeImg from "../assets/img/time.png";
import botDefaultImg from "../assets/img/bot.svg";
import botAGTImg from "../assets/img/AGT/bot.svg";
import botETRADEImg from "../assets/img/ETRADE/bot.svg";
import botTRADINGMOONlightImg from "../assets/img/TRADINGMOON/bot.lightTheme.svg";
import botTRADINGMOONdarkImg from "../assets/img/TRADINGMOON/bot.darkTheme.svg";
import botSKILLINGlightImg from "../assets/img/SKILLING/bot.lightTheme.svg";
import botSKILLINGdarkImg from "../assets/img/SKILLING/bot.darkTheme.svg";

import botLogoAGTImg from "../assets/img/AGT/bot_logo.svg";
import botLogoETRADEImg from "../assets/img/ETRADE/bot_logo.svg";
import botLogoTRADINGMOONlightImg from "../assets/img/TRADINGMOON/bot_logo.lightTheme.svg";
import botLogoTRADINGMOONdarkImg from "../assets/img/TRADINGMOON/bot_logo.darkTheme.svg";
import botLogoSKILLINGlightImg from "../assets/img/SKILLING/bot_logo.lightTheme.svg";
import botLogoSKILLINGdarkImg from "../assets/img/SKILLING/bot_logo.darkTheme.svg";

import dis from "../assets/img/dislike.png";
import like from "../assets/img/like.png";
import enterBtn from "../assets/img/enterBtn.svg";
import Ada from "../assets/img/ADA.png";
import stopBtn from "../assets/img/stopBtn.svg";
import checkedImg from "../assets/img/checked.svg";
import botSLogo from "../assets/img/botSLogo.svg";
import exclamation from "../assets/img/warning.svg";
import Enter from "../assets/img/Enter.svg";
import CopyImg from "../assets/img/CopySign.svg";
import toggleFlat from "../assets/img/toggle-flat.svg";
import closeArrowHover from "../assets/img/close-arrow-hover.svg";
import openArrowHover from "../assets/img/open-arrow-hover.svg";
import brandBZLogo from "../assets/img/BZ/brandLogo.svg";
import headerBZLogo from "../assets/img/BZ/headerLogo.svg";
import logoBrand from "../assets/img/logo_brand.svg";
import closeWidget from "../assets/img/closeWidget.svg";

// New assets for the scroll-to-bottom button
import arrowDownSVG from "../assets/img/arrowDown.svg";
import roundForArrowDownSVG from "../assets/img/roundForArrowDown.svg";

// Follow-up questions CSV files
import questions_index from "../ds/follow_up_questions/follow_up_questions_INDEX.csv";
import questions_crypto from "../ds/follow_up_questions/follow_up_questions_CRYPTO.csv";
import questions_etf from "../ds/follow_up_questions/follow_up_questions_ETF.csv";
import questions_stock from "../ds/follow_up_questions/follow_up_questions_STOCK.csv";
import questions_fx from "../ds/follow_up_questions/follow_up_questions_FX.csv";
import questions_startup from "../ds/follow_up_questions/follow_up_questions_STARTUP.csv";
import introductory_question from "../ds/follow_up_questions/Introductory_question.csv";

// Export assets
export const logo = logoImg;
export const chats = chatImg;
export const portfolio = s2;
export const node = s3;
export const settings = s4;
export const help = s5;
export const name = s6;
export const SP = s7;
export const down = s8;
export const eth = s9;
export const up = s10;
export const bit = s11;
export const time = timeImg;
export const bot = {
  'default': botDefaultImg,
  'AGT': botAGTImg,
  'E-TRADE': botETRADEImg,
  'TRADINGMOON': [botTRADINGMOONlightImg, botTRADINGMOONdarkImg],
  'SKILLING': [botSKILLINGlightImg, botSKILLINGdarkImg]
};
export const bot_logo = {
  'default': botSLogo,
  'AGT': botLogoAGTImg,
  'E-TRADE': botLogoETRADEImg,
  'TRADINGMOON': [botLogoTRADINGMOONlightImg, botLogoTRADINGMOONdarkImg],
  'SKILLING': [botLogoSKILLINGlightImg, botLogoSKILLINGdarkImg]
};
export const dislike = dis;
export const lik = like;
export const enterButton = enterBtn;
export const ada = Ada;
export const stopButton = stopBtn;
export const checkedButton = checkedImg;
export const botLogo = botSLogo;
export const exclamationMark = exclamation;
export const enter = Enter;
export const copySign = CopyImg;
export const logoBrandImg = logoBrand;
export const toggleFlatBtn = toggleFlat;
export const closeArrowHoverBtn = closeArrowHover;
export const openArrowHoverBtn = openArrowHover;
export const brandLogo = { 'default': '', 'BENZINGA': brandBZLogo };
export const headerLogo = { 'default': '', 'BENZINGA': headerBZLogo };
export const closeWidgetBtn = closeWidget;
export const followUpQuestions = [
  questions_index,
  questions_crypto,
  questions_etf,
  questions_stock,
  questions_fx,
  questions_startup,
  introductory_question
];
export const BZ = "BENZINGA";

// Export new arrow assets for scroll-to-bottom button
export const arrowDown = arrowDownSVG;
export const roundForArrowDown = roundForArrowDownSVG;

// (Optionally, export other utilities as needed.)
